import { combineReducers } from 'redux'
import { CommonState, CommonReducer } from './common/common.reducer'
import { StatisticsUserState, StatisticsUserReducer } from './statistics/statistics.user.reducer'
import { StatisticsEditorState, StatisticsEditorReducer } from './statistics/statistics.editor.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface StatisticsRootState {
  commonStore: CommonState
  statisticsUserStore: StatisticsUserState
  statisticsEditorStore: StatisticsEditorState
}

export const statisticsRootReducer = combineReducers<StatisticsRootState>({
  commonStore: CommonReducer,
  statisticsUserStore: StatisticsUserReducer,
  statisticsEditorStore: StatisticsEditorReducer,
})
